import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableHead,
} from "@mui/material";
import {
  StyledTableCellValueTemplate,
  StyledTableCellLabelTemplate,
  LabelTemplate,
  StyledTableRowTemplate,
  StyledTableContainer,
} from "../../styles/table";
import { Employee } from "../../../types/processTypes";
import { tt } from "../../../../../data/langUtility";
import { formatReferenceNumber } from "../../../utils/referenceNumber";
import { format, isValid } from "date-fns";

type DateLike = Date | string | undefined | null;

const safeFormatDate = (value: DateLike, dateFormat: string): string => {
  if (value == null || value === "") return "";
  const d = new Date(value);
  return isValid(d) ? format(d, dateFormat) : "";
};

const safeCvLangDateCell = (value: DateLike, cvLang: string): string => {
  if (value == null || value === "") return "";
  const d = new Date(value);
  if (!isValid(d)) return "";
  return cvLang === "en"
    ? format(d, "dd-MMM-yyyy")
    : d.toLocaleDateString("ar-SA", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
};

interface Props {
  currentEmployee: Employee;
  template: LabelTemplate;
}

export const BasicReference = ({ currentEmployee, template }: Props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        borderRadius: template.borderRadius,
        marginBottom: 0,
        borderColor: template.borderColor,
        borderWidth: template.borderWidth,
        borderStyle: template.borderStyle,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableBody>
          <StyledTableRowTemplate template={template} key="33">
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "13%" }}
            >
              {tt("referenceNumber", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "22%" }}
            >
              {formatReferenceNumber(currentEmployee.referenceNumber)}
            </StyledTableCellValueTemplate>
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "15%" }}
            >
              {tt("referenceNumber", "ar")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "15%" }}
            >
              {tt("applicationDate", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "20%" }}
            >
              {safeCvLangDateCell(
                currentEmployee.additionalData?.documentReceivedDate,
                template.cvLang,
              )}
            </StyledTableCellValueTemplate>
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "15%", textAlign: "right" }}
            >
              {tt("applicationDate", "ar")}
            </StyledTableCellLabelTemplate>
          </StyledTableRowTemplate>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export const BasicReferenceEnglish = ({ currentEmployee, template }: Props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        borderRadius: template.borderRadius,
        marginBottom: 0,
        borderColor: template.borderColor,
        borderWidth: template.borderWidth,
        borderStyle: template.borderStyle,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableBody>
          <StyledTableRowTemplate template={template} key="33">
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "13%" }}
            >
              {tt("referenceNumber", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "22%" }}
            >
              {formatReferenceNumber(currentEmployee.referenceNumber)}
            </StyledTableCellValueTemplate>

            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "15%" }}
            >
              {tt("applicationDate", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "20%" }}
            >
              {safeFormatDate(
                currentEmployee.additionalData?.documentReceivedDate,
                "dd-MMM-yyyy",
              )}
            </StyledTableCellValueTemplate>
          </StyledTableRowTemplate>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export const BasicReferenceVer = ({ currentEmployee, template }: Props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        borderRadius: template.borderRadius,
        marginBottom: 0,
        borderColor: template.borderColor,
        borderWidth: template.borderWidth,
        borderStyle: template.borderStyle,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableBody>
          <StyledTableRowTemplate template={template} key="33">
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "10%" }}
            >
              {tt("referenceNumber", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "28%" }}
            >
              {formatReferenceNumber(currentEmployee.referenceNumber)}
            </StyledTableCellValueTemplate>
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "12%" }}
            >
              {tt("referenceNumber", "ar")}
            </StyledTableCellLabelTemplate>
          </StyledTableRowTemplate>
          <StyledTableRowTemplate template={template} key="333">
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "12%" }}
            >
              {tt("applicationDate", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "26%" }}
            >
              {safeCvLangDateCell(
                currentEmployee.additionalData?.documentReceivedDate,
                template.cvLang,
              )}
            </StyledTableCellValueTemplate>
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "12%" }}
            >
              {tt("applicationDate", "ar")}
            </StyledTableCellLabelTemplate>
          </StyledTableRowTemplate>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export const BasicReferenceDateOnly = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        borderRadius: template.borderRadius,
        marginBottom: 0,
        borderColor: template.borderColor,
        borderWidth: template.borderWidth,
        borderStyle: template.borderStyle,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableBody>
          <StyledTableRowTemplate template={template} key="333">
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "20%" }}
            >
              {tt("applicationDate", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "60%" }}
            >
              {safeCvLangDateCell(
                currentEmployee.additionalData?.documentReceivedDate,
                template.cvLang,
              )}
            </StyledTableCellValueTemplate>
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "20%" }}
            >
              {tt("applicationDate", "ar")}
            </StyledTableCellLabelTemplate>
          </StyledTableRowTemplate>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export const BasicReferenceDateOnlyEnglish = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        borderRadius: template.borderRadius,
        marginBottom: 0,
        borderColor: template.borderColor,
        borderWidth: template.borderWidth,
        borderStyle: template.borderStyle,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableBody>
          <StyledTableRowTemplate template={template} key="333">
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "20%" }}
            >
              {"Application Date"}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "60%" }}
            >
              {safeFormatDate(
                currentEmployee.additionalData?.documentReceivedDate,
                "dd-MMM-yyyy",
              )}
            </StyledTableCellValueTemplate>
          </StyledTableRowTemplate>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export const BasicReferenceDateOnlyHeader = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        borderRadius: template.borderRadius,
        marginBottom: 0,
        borderColor: template.borderColor,
        borderWidth: template.borderWidth,
        borderStyle: template.borderStyle,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableHead>
          <StyledTableRowTemplate template={template} key="333">
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "20%" }}
            >
              {tt("applicationDate", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{ width: "60%" }}
            >
              {safeCvLangDateCell(
                currentEmployee.additionalData?.documentReceivedDate,
                template.cvLang,
              )}
            </StyledTableCellValueTemplate>
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ width: "20%" }}
            >
              {tt("applicationDate", "ar")}
            </StyledTableCellLabelTemplate>
          </StyledTableRowTemplate>
        </TableHead>
      </Table>
    </TableContainer>
  );
};

export const BasicReferenceOnly = ({ currentEmployee, template }: Props) => {
  return (
    <StyledTableContainer
      template={template}
      sx={{
        marginBottom: 0,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableBody>
          <StyledTableRowTemplate template={template} key="33">
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ textAlign: "left" }}
            >
              {tt("referenceNumber", "en")}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate template={template}>
              {formatReferenceNumber(currentEmployee.referenceNumber)}
            </StyledTableCellValueTemplate>
            <StyledTableCellLabelTemplate
              template={template}
              sx={{ textAlign: "right" }}
            >
              {tt("referenceNumber", "ar")}
            </StyledTableCellLabelTemplate>
          </StyledTableRowTemplate>
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export const BasicReferenceOnlyEnglish = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <StyledTableContainer
      template={template}
      sx={{
        marginBottom: 0,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableBody>
          <StyledTableRowTemplate template={template} key="33">
            <StyledTableCellLabelTemplate
              template={{
                ...template,
                bodyHeight: 52,
              }}
              sx={{
                textAlign: "left",
                backgroundColor: template.headBgColor,
                color: template.headFontColor,
                width: "50%",
              }}
            >
              {"Reference Number"}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{
                width: "50%",
              }}
            >
              {formatReferenceNumber(currentEmployee.referenceNumber)}
            </StyledTableCellValueTemplate>
          </StyledTableRowTemplate>
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};
export const BasicReferenceOnlyEnglishGolden = ({
  currentEmployee,
  template,
}: Props) => {
  return (
    <StyledTableContainer
      template={template}
      sx={{
        marginBottom: 0,
      }}
    >
      <Table size="small" aria-label="simple table">
        <TableBody>
          <StyledTableRowTemplate template={template} key="33">
            <StyledTableCellLabelTemplate
              template={{
                ...template,
                bodyHeight: 52,
              }}
              sx={{
                textAlign: "left",
                backgroundColor: template.headBgColor,
                color: template.headFontColor,
                width: "35%",
              }}
            >
              {"Reference Number"}
            </StyledTableCellLabelTemplate>
            <StyledTableCellValueTemplate
              template={template}
              sx={{
                width: "65%",
              }}
            >
              {formatReferenceNumber(currentEmployee.referenceNumber)}
            </StyledTableCellValueTemplate>
          </StyledTableRowTemplate>
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};
